import { css } from 'aphrodite';
import * as React from 'react';
import HorizontalBarChart from './charts/HorizontalBarChart';
import { TrendItem } from 'src/models/TrendItem';
import { TrendChart } from './charts/TrendChart';
import { ChartItem } from 'src/models/ChartItem';
import { Card, CardHeader, CardBody, ListGroup, ListGroupItem, Modal, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';
import { PublicationListItem } from 'src/models/PublicationListItem';
import { styles } from 'src/styles/AuthorPublications';
import { Author} from "src/models/CoAuthor";
import axios from "axios";
import { sortTrend } from 'src/models/TrendItem';
import { buildTrendItemExp } from '../models/TrendItem';
import { sortItem } from 'src/mobx/FacultyPageStore';
import { appStore } from 'src/mobx/AppStore';
import { RequestState } from 'src/models/RequestState';
import { Api } from '../core/api';
import { observer, inject } from 'mobx-react';
import { ExpenditureProjectDialog} from "src/components/dialogs/ExpenditureProjectDialog"
import { ExpenditureDepartmentDialog} from "src/components/dialogs/ExpenditureDepartmentDialog"
import { ProjectDetailDialog } from "src/components/dialogs/ProjectDetailDialog"
import { CombinedInfo } from './CombinedInfo';
import millify from "millify";
import { start } from 'repl';
import { URLBuilder } from 'src/core/URLBuilder';
import { AbbreviationItem } from 'src/models/AbbreviationItem';

interface IAuthorExpenditureProps {
    author_id: string;
    first_name: string;
    last_name: string;
}

class AuthorExpenditureState {
    public readonly selected_co_investigators_tab: number;
    public readonly isTrendBarSelected: boolean;
    public readonly selectedYear: number;
    public readonly modal: boolean;
    public readonly isProjectExpanded: boolean;
    public readonly isDepartmentExpanded: boolean;
    public readonly isProjectDetailDialogOpen: boolean;
    public readonly clickedProjectID: string;
    public readonly startYear: number;
    public readonly endYear: number;

    constructor(){
        this.selected_co_investigators_tab = 0;
        this.isTrendBarSelected = false;
        this.selectedYear = 0;
        this.modal = false;
        this.isProjectExpanded = false;
        this.isDepartmentExpanded = false;
        this.isProjectDetailDialogOpen= false;
        this.clickedProjectID = "";
        this.startYear = new Date().getFullYear() - 5;
        this.endYear = new Date().getFullYear();
    }
}


@inject('store')
@observer
export class AuthorExpenditures extends React.Component<IAuthorExpenditureProps, AuthorExpenditureState> {
    
    constructor(props: IAuthorExpenditureProps) {
        super(props)
        this.state = new AuthorExpenditureState();     
    }
   
    public async componentDidMount() {
        const author_id = this.props.author_id;
        //const author_id = "89";
        if(this.state.isTrendBarSelected){
            this.fetchDataForRange(this.state.startYear, this.state.endYear);
            this.fetchDataForYear(this.state.selectedYear,author_id);
        }else{
            this.fetchDataForRange(this.state.startYear, this.state.endYear);
        }        
                
    }
    
    private fetchTrendDataForRange = (startYear: number, endYear: number) => {
        const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        expenditureData.expenditures_over_time.setRequestState(RequestState.LOADING);
        axios.get(URLBuilder.expenditure_over_time_for_range(this.props.author_id, startYear, endYear)).then((res)=> {
            if(res.status === 200){
                const expenditures = res.data.expenditures.map(buildTrendItemExp).sort(sortTrend);
                expenditureData.expenditures_over_time.setData(expenditures);
            }else{
                const error = res.statusText + ":" + res.data
                expenditureData.expenditures_over_time.setError(error);
            }    
        }).catch((err)=>{
            expenditureData.expenditures_over_time.setError(err.toString());
        });
    }

    private fetchDataForYear  = (year: number, author_id: string) => {
        this.fetchExpenditureByProjectForYear(year,author_id);
        this.fetchExpenditureByDepartmentForYear(year,author_id);
    }

    private fetchDataForRange  = (startYear: number, endYear: number) => {
        this.fetchTrendDataForRange(this.state.startYear, this.state.endYear);
        this.fetchExpenditureByProjectForRange(startYear, endYear);
        this.fetchExpenditureByDepartmentForRange(startYear, endYear);
    }

    private fetchExpenditureByProjectForYear = (year: number, author_id: string) => {
        const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        expenditureData.expenditures_by_project.setRequestState(RequestState.LOADING);
        const url = URLBuilder.expenditure_by_project(author_id, year)

        axios.get(url).then((res)=> {
            if(res.status === 200){
                const expenditures = res.data.expenditures.map(this.buildProjectChartItem).sort(sortItem);
                expenditureData.expenditures_by_project.setData(expenditures);
            }else{
                const error = res.statusText + ":" + res.data
                expenditureData.expenditures_by_project.setError(error);
            }    
        }).catch((err)=>{
            expenditureData.expenditures_by_project.setError(err.toString());
        });
    }

    private fetchExpenditureByProjectForRange = (startYear: number, endYear: number) => {
        const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        expenditureData.expenditures_by_project.setRequestState(RequestState.LOADING);
        const url = URLBuilder.expenditure_by_project_for_range(this.props.author_id, startYear, endYear)

        axios.get(url).then((res)=> {
            if(res.status === 200){
                const expenditures = res.data.expenditures.map(this.buildProjectChartItem).sort(sortItem);
                expenditureData.expenditures_by_project.setData(expenditures);
            }else{
                const error = res.statusText + ":" + res.data
                expenditureData.expenditures_by_project.setError(error);
            }    
        }).catch((err)=>{
            expenditureData.expenditures_by_project.setError(err.toString());
        });
    }

    private fetchExpenditureByDepartmentForYear = (year: number, author_id: string) => {
        const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        expenditureData.expeditures_by_department.setRequestState(RequestState.LOADING);
        const url = URLBuilder.expenditure_by_department(author_id, year)

        axios.get(url).then((res)=> {
            if(res.status === 200){
                const expenditures = res.data.expenditures.map(this.buildDepartmentChartItem).sort(sortItem);
                expenditureData.expeditures_by_department.setData(expenditures);
            }else{
                const error = res.statusText + ":" + res.data
                expenditureData.expeditures_by_department.setError(error);
            }    
        }).catch((err)=>{
            expenditureData.expeditures_by_department.setError(err.toString())
        });
    }

    private fetchExpenditureByDepartmentForRange = (startYear: number, endYear: number) => {
        const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        expenditureData.expeditures_by_department.setRequestState(RequestState.LOADING);
        const url = URLBuilder.expenditure_by_department_for_range(this.props.author_id, startYear, endYear)

        axios.get(url).then((res)=> {
            if(res.status === 200){
                const expenditures = res.data.expenditures.map(this.buildDepartmentChartItem).sort(sortItem);
                expenditureData.expeditures_by_department.setData(expenditures);
            }else{
                const error = res.statusText + ":" + res.data
                expenditureData.expeditures_by_department.setError(error);
            }    
        }).catch((err)=>{
            expenditureData.expeditures_by_department.setError(err.toString())
        });
    }

    public render() {
        return (
            <React.Fragment>
                <div id="div_content" className={css(styles.content)} >
                        {this.renderOverview()}
                        {this.renderCharts()}
                </div>
                {this.buildProjectExpandDialog()}
                {this.buildDepartmentExpandDialog()}
                {this.buildProjectDetailDialog()}
            </React.Fragment>
            
        );
    }

    public renderOverview = () => {

        const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;        
        return (
            <div id="overview" className={css(styles.overview)} >

                <TrendChart 
                            state={expenditureData.expenditures_over_time.requestState}
                            data={expenditureData.expenditures_over_time.data}
                            error={expenditureData.expenditures_over_time.error}
                            title={`${facultyName} Expenditure over time`}
                            onTrendBarClick={this.onTrendBarClick}
                            onTrendSelectionCleared={this.onTrendBarCleared}
                            labelName={"Year"}
                            valueLabel={"Amount"}
                            valueFormatter={this.formatValues}
                            verticalTickFormatter={this.tickFormatter}
                            initStartYear={this.state.startYear}
                            initEndYear={this.state.endYear}
                            onRangeChanged={this.onRangeChanged}
                            />

                <CombinedInfo author_id={this.props.author_id} startYear={this.state.startYear} endYear={this.state.endYear} />

            </div>
        );
    }

    public renderCharts = () => {
        const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        
        let projectTitle;
        let projectToolTip;
        let departmentTitle;
        let departmentToolTip;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;  
        const startYear = this.state.startYear;
        const endYear = this.state.endYear
        
        if(this.state.selectedYear === 0 ){
            projectTitle = `${facultyName} Expenditure by Project from FY ${startYear} to FY ${endYear}`;
            projectToolTip = `FY ${startYear} to FY ${endYear} (as reported on scopus.com)`;
            departmentTitle = `${facultyName} Expenditure by Unit from FY ${startYear} to FY ${endYear}`;
            departmentToolTip = `For top 10 cited since FY ${startYear} to FY ${endYear} (as reported on scopus.com)`;
        }else{
            projectTitle = `${facultyName} Expenditure by Project for Year: FY ${this.state.selectedYear}`;
            projectToolTip = `Year: FY ${this.state.selectedYear} (as reported on scopus.com)`;
            departmentTitle = `${facultyName} Expenditure by Unit for Year: FY ${this.state.selectedYear}`;
            departmentToolTip = `For top 10 cited in FY ${this.state.selectedYear} (as reported on scopus.com)`;
        }

        return (
            <div id="charts_container" className={css(styles.charts_container)} >
                                <HorizontalBarChart id="project"
                                        state={expenditureData.expenditures_by_project.requestState}
                                        data={expenditureData.expenditures_by_project.data.slice(0,10)}
                                        error={expenditureData.expenditures_by_project.error}
                                        title={projectTitle}
                                        tooltip={projectToolTip}
                                        labelName={"Project"}
                                        valueLabel={"Amount"}
                                        valueFormatter={this.formatValues}
                                        onExpandClick={this.onProjectExpandClick}
                                        onItemClick={this.onProjectClick}
                                        tickFormatter={this.tickFormatter}
                                        />

                                <HorizontalBarChart id="unit"
                                                state={expenditureData.expeditures_by_department.requestState}
                                                data={expenditureData.expeditures_by_department.data.slice(0,10)}
                                                error={expenditureData.expeditures_by_department.error}
                                                title={departmentTitle}
                                                tooltip={departmentToolTip}
                                                labelName={"Unit"}
                                                valueLabel={"Amount"}
                                                valueFormatter={this.formatValues}
                                                onExpandClick={this.onDepartmentExpandClick}
                                                tickFormatter={this.tickFormatter}
                                                />                                 
        
            </div>
        )
    }

    private onRangeChanged = (startYear: number, endYear: number) => {
        const newState = {...this.state, startYear: startYear, endYear: endYear};
        this.setState(newState);
        this.fetchDataForRange(startYear, endYear);
    }

    private onProjectClick = (chartItem: ChartItem ) => {
        const newState = {...this.state, isProjectDetailDialogOpen: true, clickedProjectID: chartItem.payload};
        //this.setState(newState);
    }

    private buildProjectDetailDialog = () => {
        return (
            <ProjectDetailDialog isOpen={this.state.isProjectDetailDialogOpen} onClose={this.onProjectDetailClose} id={this.state.clickedProjectID} />
        );
    }
        
    private onProjectDetailClose = () => {
        const newState = {...this.state, isProjectDetailDialogOpen: false, clickedProjectID: ""};
        this.setState(newState);
    }


    private onProjectExpandClick = () => {
        const newState = {...this.state, isProjectExpanded: true};
        this.setState(newState);
    }

    private buildProjectExpandDialog = () => {
        return (
            <ExpenditureProjectDialog isOpen={this.state.isProjectExpanded} onClose={this.onProjectClose} />
        );
    }

    private onProjectClose = () => {
        const newState = {...this.state, isProjectExpanded: false};
        this.setState(newState);
    }
   

    private onDepartmentExpandClick = () => {
        const newState = {...this.state, isDepartmentExpanded: true};
        this.setState(newState);
    }

    private buildDepartmentExpandDialog = () => {
        return (
            <ExpenditureDepartmentDialog isOpen={this.state.isDepartmentExpanded} onClose={this.onDepartmentClose} />
        );
    }

    private onDepartmentClose = () => {
        const newState = {...this.state, isDepartmentExpanded: false};
        this.setState(newState);
    }
    
    public formatValues = (value: string) => {
        return "$"+ millify(+value);
    }

    private tickFormatter = (value: string) => {
        return "$" + millify(+value);
    }

    private buildProjectChartItem = (data: any) => {
        const label = data.project_description;
        const value = data.expenditure;
        return new ChartItem(label,value,data.UD_project_id);
    }

    private buildDepartmentChartItem = (data: any) => {
        const abbr_item = new AbbreviationItem();
        abbr_item.name = data.dept_description;
        abbr_item.name_abbr = data.dept_abbr;
        const value = data.expenditure;
        return new ChartItem(JSON.stringify(abbr_item),value,false);
    }


    private toggleModal = () => {
        this.setState({...this.state, modal: !this.state.modal})
    }

    private onTrendBarClick = (entry: TrendItem,index: number) => {
        this.setState({...this.state, isTrendBarSelected: true, selectedYear: entry.year});
        this.fetchDataForYear(entry.year,this.props.author_id);
    }

    private onTrendBarCleared = () => {
        this.setState({...this.state,isTrendBarSelected: false, selectedYear: 0});
        this.fetchDataForYear(0,this.props.author_id);
    }

    
        
}




// WEBPACK FOOTER //
// ./src/components/AuthorExpenditures.tsx